import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Autocomplete,
  TextField,
  Box,
  Typography,
} from '@mui/material';
import {
  formatUserRoles,
  getUserDisplayLabel,
} from '../leadAssignUserHelpers';

const AssignDialog = ({
  open,
  selectedLead,
  selectedUsers = [],
  usersList = [],
  usersLoading = false,
  processingId,
  onClose,
  onUsersChange,
  onAssign,
}) => {
  const selectedUserId = selectedUsers?.[0] ?? null;
  const selectedUserObj =
    usersList.find((u) => String(u.id) === String(selectedUserId)) ?? null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Assign Lead to User</DialogTitle>
      <DialogContent>
        <Autocomplete
          loading={usersLoading}
          disabled={usersLoading}
          value={selectedUserObj}
          onChange={(event, newValue) => {
            onUsersChange(newValue ? [newValue.id] : []);
          }}
          options={usersList}
          noOptionsText={usersLoading ? 'Loading users...' : 'No users found'}
          getOptionLabel={(option) => getUserDisplayLabel(option)}
          filterOptions={(options, { inputValue }) => {
            const query = inputValue.trim().toLowerCase();
            if (!query) return options;
            return options.filter((option) => {
              const roles = formatUserRoles(option).toLowerCase();
              return (
                (option.name || '').toLowerCase().includes(query) ||
                (option.email || '').toLowerCase().includes(query) ||
                roles.includes(query)
              );
            });
          }}
          renderOption={(props, option) => {
            const roles = formatUserRoles(option);
            return (
              <Box component="li" {...props} key={option.id}>
                <Box>
                  <Typography variant="body2">{option.name}</Typography>
                  {option.email && (
                    <Typography variant="caption" color="text.secondary" display="block">
                      {option.email}
                    </Typography>
                  )}
                  {roles && (
                    <Typography variant="caption" color="text.secondary" display="block">
                      {roles}
                    </Typography>
                  )}
                </Box>
              </Box>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Search & select user..."
              placeholder="Type name or email..."
              margin="normal"
              fullWidth
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {usersLoading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          isOptionEqualToValue={(option, value) =>
            String(option.id) === String(value?.id)
          }
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onAssign}
          variant="contained"
          disabled={
            usersLoading || !selectedUserObj || processingId === selectedLead?.id
          }
          startIcon={
            processingId === selectedLead?.id ? <CircularProgress size={20} /> : null
          }
        >
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignDialog;
